import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.myfootballgame.com';
const SITE_NAME = 'My Football Game';
const DEFAULT_IMAGE = SITE_URL + '/og-image.jpg';

export default function Seo({ title, description, path = '/', jsonLd, lang = 'en', alternates }) {
  const url = SITE_URL + path;

  return (
    <Helmet>
      <html lang={lang} />
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      {alternates?.map(([hreflang, href]) => (
        <link key={hreflang} rel="alternate" hrefLang={hreflang} href={SITE_URL + href} />
      ))}
      <meta property="og:locale" content={{ pt: 'pt_PT', es: 'es_ES' }[lang] || 'en_US'} />

      <meta property="og:url" content={url} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      <meta property="og:image" content={DEFAULT_IMAGE} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:type" content="website" />

      <meta name="twitter:card" content="summary_large_image" />
      {title && <meta name="twitter:title" content={title} />}
      {description && <meta name="twitter:description" content={description} />}
      <meta name="twitter:image" content={DEFAULT_IMAGE} />

      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}
